import React from 'react';
import { RulerType } from 'constants/constants';

import styles from './Ruler.module.scss';

type RulerProps = {
  className?: RulerType | string; // 'MAIN' | 'SUB' | 'STEEL' | 'PLAYOFF_LEADER' | 'PLAYOFF_WILDCARD' | 'PLAYOFF_HUNT'
  marginStyle?: string;
} & Pick<React.HTMLProps<HTMLHRElement>, 'style' | 'onClick'>;

const Ruler: React.FC<RulerProps> = ({ className = 'SUB', marginStyle = '', style, ...props }) => {
  const baseCls = `${styles.RulerContainer} ${className} ${marginStyle}`;
  const hr = <hr style={style} className={baseCls} onClick={props.onClick} />;
  return hr;
};

export default Ruler;
